<div
	class="surface-0 flex align-items-center justify-content-center min-h-screen overflow-hidden"
>
	<div class="grid justify-content-center p-2 lg:p-0 mb-5" >
		<div class="col-12 mt-5 xl:mt-0 text-center">
			<img
				src="assets/img/logo_white.png"
				class="mb-5 mt-4"
				style="border-radius: 5px"
			/>
		</div>
		<div
			class="col-10 xl:col-10"
			style="
				border-radius: 16px;
				padding: 0.3rem;
				background: linear-gradient(
					180deg,
					rgba(255, 255, 255, 0.65) 40%,
					rgba(255, 255, 255, 0.75) 80%
				);
				border: solid 3px rgba(255, 255, 255, 0.75);
			"
		>
			<div
				class="h-full w-full m-0 py-7 px-4 form-conditions-general" >
				<div class="text-center mb-5">
					<div
						class="text-900 text-3xl font-bold mb-3"
						style="font-family: Albert Sans Regular"
					>
						Condiciones generales de uso
					</div>
				</div>
				<div class="w-full md:w-10 mx-auto" style="color:black;font-size:15px;text-align: justify;">
					<p>Fecha última actualización: 05/05/2025</p>
					<h5 class="font-bold">1. TITULARIDAD.</h5>
					<p>
						El presente documento tiene por objeto establecer las condiciones generales de uso de la aplicación [NOMBRE DE LA
						APLICACIÓN] ______________________________ (en adelante, la Aplicación), titularidad de SEPSUS MEDIA
						GROUP SL, con CIF/NIF nº: B88251764 y domicilio a efectos de notificaciones en: Calle Menorca, 2, C.P. 28223 -
						Pozuelo de Alarcón (Madrid), constando dicha entidad inscrita en el Registro Mercantil de
						____________________________________,
						Tomo ________, Folio ______, Sección ___ª, Hoja ____________, inscripción ___ª (en adelante, el Propietario).<br>
						El registro y posterior uso de la Aplicación, requiere la aceptación previa por parte del usuario, de las condiciones
						generales de uso vigentes. El Propietario se reserva el derecho de modificar las presentes condiciones, en cualquier
						momento, si bien dichos cambios serán debidamente informados para el conocimiento por parte del usuario.<br>
						La descarga y uso de la aplicación, atribuye la condición de usuario de la misma (en adelante, el Usuario) e implica la
						lectura, entendimiento y aceptación de todos los términos y condiciones recogidos por el presente documento.<br>
						No obstante, el Usuario deberá revisar periódicamente las publicaciones relativas a los cambios efectuados en las
						condiciones de uso, y si aquél continúa utilizando la Aplicación, se entenderá que ello implica la aceptación y asunción
						de dichos cambios.<br>
						Las presentes condiciones de uso, afectan a tus derechos y obligaciones legales respecto al uso de la Aplicación. Si no
						aceptas los términos incluidos en las mismas, no debes registrarte, acceder, ni utilizar la Aplicación.
					</p>
					
					<h5 class="font-bold">2. MENORES DE EDAD.</h5>
					<p>
						De conformidad con las disposiciones vigentes en materia de protección de datos personales, y en aras a proteger la
privacidad de los menores de edad, se informa de que el Usuario debe ser mayor de catorce (14) años o disponer de
autorización expresa de sus padres y/o tutores legales, para poder registrarse, acceder y utilizar la presente Aplicación.<br>
A tal fin, el Propietario podrá ponerse en contacto con el Usuario en cualquier momento para que acredite su identidad
y la edad real que le habilitaría para el uso de la Aplicación, o bien para que demuestre disponer de autorización de sus
padres y/o tutores legales.<br>
Entre los documentos que el Propietario podrá solicitar al Usuario para acreditar los puntos anteriormente señalados, se
encontrarían una copia de su DNI, así como otros documentos complementarios que sean necesarios para que el
Propietario verifique la edad real del Usuario. En caso de que el Propietario solicite la citada documentación al Usuario,
y éste se niegue a aportarla, el Propietario podrá dar de baja de la Aplicación al Usuario.
					</p>
					
					<h5 class="font-bold">3. DERECHOS DE PROPIEDAD INTELECTUAL.</h5>
					<p>
						La Aplicación es una obra compuesta de diversos elementos integrados e inseparables (texto, ilustraciones, fotografías,
imágenes animadas, vídeos, programas de ordenador, etc.), cuyos derechos de propiedad intelectual, en virtud de lo
dispuesto por la normativa vigente en la materia, corresponden al Propietario, salvo en lo referente a aquellos
materiales obtenidos bajo licencia, autorización o consentimiento de terceros.<br>
El Propietario y los terceros licenciantes, retendrán en todo momento los derechos de propiedad intelectual sobre la
Aplicación, así como sobre los diferentes elementos que la componen, considerados de forma individual, en todas las
copias que se realicen (cualquiera que sea el soporte al que se incorporen), concediendo sobre los mismos únicamente
el derecho de uso.<br>
Cualquier derecho que no sea expresamente cedido, se entenderá reservado en favor del Propietario y los licenciantes
de contenidos o elementos individuales.<br>
El Propietario dispone de los derechos de propiedad intelectual y de explotación sobre el software empleado para el
desarrollo y funcionamiento de la Aplicación, y estará habilitado para descargar e instalar nuevas versiones del software
de la Aplicación, actualizaciones y mejoras, con el fin de perfeccionar las funcionalidades del servicio.<br>
El usuario no adquiere derecho alguno o licencia por el servicio contratado, sobre el software necesario para la
prestación del servicio, ni tampoco sobre la información técnica de seguimiento del servicio, a excepción de los
derechos y licencias necesarios para la utilización y correcto funcionamiento de la Aplicación.<br>
Además de lo anterior, el Propietario es responsable de la selección, diseño de la estructura y disposición de los
contenidos de la Aplicación, así como quien ha tomado la iniciativa y asumido el riesgo de efectuar las inversiones
sustanciales orientadas a la obtención, digitalización y presentación de la misma, correspondiéndole, por tanto, la
protección que la Ley de Propiedad Intelectual (LPI) pueda conceder sobre dicha disposición y estructuración de datos.
El Propietario es también el único titular del diseño e imagen gráfica de la Aplicación, reservándose las acciones que
legalmente le correspondan contra las personas que pudieran realizar imitaciones o usos desleales de la misma.
					</p>
					
					
					<h5 class="font-bold">4. DERECHOS DEL USUARIO.</h5>
					<p>
						Respecto a los posibles contenidos generados por el usuario, durante el uso de la Aplicación, aquél será el único titular
de los derechos de propiedad intelectual sobre dichos contenidos.<br>
No obstante, cuando el Usuario comparta, difunda o publique contenidos en la Aplicación, está concediendo una
licencia no exclusiva, transferible y gratuita, para poder almacenar, reproducir, distribuir, modificar, mantener o
comunicar públicamente (difundir, publicar) el contenido generado por el Usuario.<br>
En el supuesto de que el Usuario, comparta o publique contenidos en la Aplicación, que no haya creado o generado él
mismo, será el único responsable de haber obtenido previamente las correspondientes autorizaciones por parte de los
legítimos autores de los citados contenidos.<br>
En cualquier caso, el Propietario informa al Usuario de que, aunque el contenido pueda ser eliminado de la interfaz de
la Aplicación, éste puede conservarse en las copias de seguridad del Propietario durante un cierto tiempo, para
después ser suprimido de forma efectiva.<br>
Asimismo, cabe mencionar que el contenido puede seguir siendo visible si se ha compartido con otros usuarios, y éstos
han llegado a descargar o guardar dicho contenido, excediendo estas actuaciones del ámbito o entorno de la
Aplicación.
					</p>

					<h5 class="font-bold">5. OBLIGACIONES DEL USUARIO.</h5>
					<p>
						El Usuario se compromete a utilizar la presente Aplicación y todo su contenido de conformidad con la ley, la moral, el
orden público y las presentes condiciones de uso. Asimismo, se compromete a hacer un uso adecuado de los servicios
y/o contenidos de la aplicación.<br>
En particular, el Usuario se compromete a:<br>
• No emplear la Aplicación para realizar actividades ilícitas o constitutivas de delito, que atenten contra
los derechos de terceros y/o que infrinjan la regulación sobre propiedad intelectual e industrial, o
cualesquiera otras normas del ordenamiento jurídico aplicable.<br>
• No transmitir, introducir, difundir y poner a disposición de terceros, cualquier tipo de material e
información (datos contenidos, mensajes, dibujos, archivos de sonido e imagen, fotografías, software,
etc.), a través de la Aplicación, que sean contrarios a la ley, la moral, el orden público y las presentes
condiciones de uso.<br>
• No generar, compartir o subir contenidos a la Aplicación, si son ilegales, engañosos, o discriminatorios,
o si vulneran los derechos de otra persona.<br>
• La publicación o transmisión de cualquier contenido que resulte violento, obsceno, abusivo, racial,
xenófobo o difamatorio.<br>
• No introducir o subir virus o códigos maliciosos, o realizar actividades susceptibles de alterar el correcto
funcionamiento de la Aplicación.<br>
• No recoger ni utilizar datos personales (incluida la imagen física) de otros usuarios sin su
consentimiento expreso o contraviniendo lo dispuesto en el Reglamento General de Protección de
Datos.<br>
La infracción de cualquiera de las normas contenidas en este apartado, facultará al Propietario, para dar de baja de la
Aplicación al usuario de manera inmediata, así como para eliminar contenidos generados por el usuario, que puedan
atentar contra los derechos de terceros, resultar inadecuados o ser contrarios al orden jurídico.
					</p>
					
					<h5 class="font-bold">6. LIMITACIÓN DE RESPONSABILIDAD.</h5>
					<p>
						El Propietario no garantiza que, durante el uso de la Aplicación, no puedan producirse fallos o errores que dificulten el
uso del servicio, generen imperfecciones, problemas o retrasos en el sistema.<br>
Siempre que el Propietario haya actuado con la diligencia oportuna y necesaria, no asumirá responsabilidad alguna por:
pérdidas no provocadas por infracción del Propietario, de lo dispuesto en las presentes condiciones; pérdidas no
previsibles de forma razonable por ninguna de las partes; contenidos difundidos o publicados por otros usuarios,
cuando vulneren derechos de terceros, o se trate de contenido ilegal, violento, ofensivo o inapropiado.
					</p>
					
					<h5 class="font-bold">7. PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL.</h5>
					<p>De conformidad con el Reglamento (UE) 2016/679, del Parlamento Europeo y del Consejo, de 27 de abril de 2016,
						relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre
						circulación de estos datos (Reglamento General de Protección de Datos - RGPD), toda información o datos de carácter
						personal que el Usuario facilite a través de la utilización de la presente App, serán tratados de acuerdo a lo establecido
						en nuestra Política de Privacidad.</p>
						
						
					<h5 class="font-bold">8. MODIFICACIONES.</h5>
					<p>El Propietario se reserva el derecho a efectuar, sin previo aviso, las modificaciones que considere oportunas para el
						correcto funcionamiento de la Aplicación, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se
						prestan a través de la misma, como la forma en la que éstos aparecen presentados o localizados.<br>
						El Propietario intentará, en la medida de lo posible, mantener actualizada y libre de fallos la información contenida en la
						presente Aplicación, si bien, en cualquier caso, el acceso y utilización de la misma es responsabilidad exclusiva del
						Usuario.</p>

						
					<h5 class="font-bold">9. ACCIONES LEGALES.</h5>
					<p>En caso de incumplimiento por parte del Usuario, de los términos incluidos en las presentes condiciones de uso, el
						Propietario estará habilitado para iniciar las acciones legales que, conforme a la legislación vigente, puedan resultar
						oportunas, así como a solicitar las indemnizaciones pertinentes por parte del Usuario.<br>
						El Propietario perseguirá cualquier utilización indebida de la Aplicación o de sus contenidos así como las infracciones
						de los derechos que le correspondan a él o a sus licenciantes, especialmente en lo relativo a los derechos de propiedad
						intelectual e industrial.</p>
				</div>
			</div>
		</div>
	</div>
</div>
